import { render } from "./LicenseProducer.vue?vue&type=template&id=7502a3d5"
import script from "./LicenseProducer.vue?vue&type=script&lang=js"
export * from "./LicenseProducer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__